import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './IconButton.css';

class IconButton extends React.Component {
    componentDidUpdate(prevProps) {
        if (this.props.focus && prevProps.focus !== this.props.focus) {
            this.ref.focus();
        }
    }
    render() {
        const {
            onClick,
            icon: Icon,
            iconProps,
            style,
            className,
            title,
            focus, // eslint-disable-line
            ...props
        } = this.props;
        return (<button
            onClick={onClick}
            className={cx(styles.noButton, className, {
                [styles.havePopover]: !!title,
            })}
            ref={(r) => {
                this.ref = r;
            }}
            style={style}
            {...props}
        >
            <Icon {...iconProps} />
            {title ? <div className={styles.popoverWrap}>
                <div className={styles.popover}>
                    {title}
                </div>
            </div> : null}
        </button>);
    }
}

IconButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.func.isRequired,
    iconProps: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
    title: PropTypes.string,
    focus: PropTypes.bool,
};

IconButton.defaultProps = {
    iconProps: {},
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/client/Components/IconButton/IconButton.js